import { multiPaymentConstants } from '../../../constants/payment/multi-payment-constants'

export const setFormStartEventEmitted = () => ({
    type: multiPaymentConstants.SET_FORM_START_EVENT_EMITTED
})

export const clearFormStartEventEmitted = () => ({
    type: multiPaymentConstants.CLEAR_FORM_START_EVENT_EMITTED
})